<div class="sdds-container no-padding stuart height-100">
  <div class="sdds-row stuart height-100 stuartModule-bkgd padding" [style.backgroundImage]="stuartBgImage !== ''? 'linear-gradient(0deg, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url('+stuartBgImage+')': ''">
    <div class="sdds-col-xxlg-16 sdds-col-xlg-16 sdds-col-lg-16 sdds-col-md-16 sdds-col-sm-16 stuart">
      <div class="sdds-col-xxlg-16 sdds-col-xlg-16 sdds-col-lg-16 sdds-col-md-16 sdds-col-sm-16">
        <div class="sdds-col-xxlg-16 sdds-col-xlg-16 sdds-col-lg-16 sdds-col-md-8 sdds-col-sm-8 text-center">
          @if (stuartTitle === '') {
            <h3 class="text-center uppercase sdds-text-white hyphenate" data-cy="super-header">{{ 'eys.stuartModuleHeader' | translate }}</h3>
          }
          @if (stuartTitle !== '') {
            <h3 class="text-center uppercase sdds-text-white hyphenate" data-cy="super-header">{{ stuartTitle }}</h3>
          }
        </div>
        <div class="sdds-col-xxlg-16 sdds-col-xlg-16 sdds-col-lg-16 sdds-col-md-8 sdds-col-sm-8">
          @if (stuartText === '') {
            <p class="sdds-text-white sdds-detail-01" data-cy="super-middle-text">{{ 'eys.stuartModuleBody' | translate }}</p>
          }
          @if (stuartText !== '') {
            <p class="sdds-text-white sdds-detail-01" data-cy="super-middle-text">{{ stuartText }}</p>
          }
        </div>
        <div class="sdds-col-xxlg-16 sdds-col-xlg-16 sdds-col-lg-16 sdds-col-md-8 sdds-col-sm-8  text-center padding-bottom">
          <a href="{{stuartUrl}}" target="_blank" id="stuartUrlLink" data-analytics="{'eventComponent':'stuart url','eventType':'link','eventLabel':'go to stuart url'}" data-cy="super-module-url">
            <button class="sdds-btn stuart sdds-btn-default uppercase" data-cy="super-button">
              @if (stuartButtonText === '') {
                <b>{{ 'eys.stuartModuleButton' | translate }}</b>
              }
              @if (stuartButtonText !== '') {
                <b>{{ stuartButtonText }}</b>
              }
            </button>
          </a>
        </div>
        <div class="sdds-col-xxlg-16 sdds-col-xlg-16 sdds-col-lg-16 sdds-col-md-8 sdds-col-sm-8">
          <p class="sdds-text-white sdds-detail-01 stuartModuleDisclaimer">{{ 'eys.stuartModuleDisclaimer' | translate }}</p>
        </div>
      </div>
    </div>
  </div>
</div>